// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heGhGKYQBAuMwPZhZUu4{min-height:unset;padding:16px 20px 12px}._YLjr8VdqkSwJFl6pd_r{align-items:center;gap:8px;margin-bottom:32px;padding-left:20px;display:flex}.K463ggHs5IgtOs6jRawH{padding-left:20px;padding-right:20px;flex-direction:column;gap:12px;padding-bottom:15px;display:flex}.S0pkqEYwMd4sk5yd_z3x{margin:0 3px}.WXPLl4keuEdmkQh8xybB{flex-direction:column;gap:8px;padding:0 20px;display:flex}.WXPLl4keuEdmkQh8xybB>:last-child{margin-bottom:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `heGhGKYQBAuMwPZhZUu4`,
	"wrapStatus": `_YLjr8VdqkSwJFl6pd_r`,
	"statistics": `K463ggHs5IgtOs6jRawH`,
	"toggle": `S0pkqEYwMd4sk5yd_z3x`,
	"alerts": `WXPLl4keuEdmkQh8xybB`
};
export default ___CSS_LOADER_EXPORT___;
